// Zendesk integration has no Blitzz-side image upload: when ALLOWZENDESK is
// on, images live in the ticket comments; when it's off, image upload is
// disabled so no images exist. Either way we just show a static message —
// there is no thumbnail grid in this app.
const ImagesPane = ({ useZendeskComments }) => {
  if (useZendeskComments) {
    return (
      <div className="empty-state">
        <div className="es-msg">
          Images can be found in the comments section of your Zendesk ticket.
        </div>
      </div>
    );
  }
  return (
    <div className="empty-state">
      <div className="es-msg">No images available for this session.</div>
    </div>
  );
};

export default ImagesPane;
